export type ProductLogoPlatform = 'client' | 'design' | 'financial' | 'sites' | 'social';

/** Each product's name as users see it, the word its logo artwork spells out. */
export const PRODUCT_NAME: Readonly<Record<ProductLogoPlatform, string>> = {
	client: 'Office',
	design: 'Design',
	financial: 'Financial',
	sites: 'Websites',
	social: 'Social',
};

/**
 * Alt text for each product's full logo.
 *
 * The artwork spells out the product name (OFFICE, SOCIAL, WEBSITES, ...), and a
 * logo is often the only content of a button or menu item. So the alt must
 * contain that word: screen readers announce it and voice control matches on it
 * (WCAG 2.1 SC 2.5.3 Label in Name). Every value keeps "logo", which smc's QA
 * locators match with `img[alt*="logo" i]`.
 *
 * Kept outside `index.tsx` on purpose: tests that mock `../BayLogo` would
 * otherwise mock this map away too.
 */
export const PRODUCT_LOGO_ALT: Readonly<Record<ProductLogoPlatform, string>> = {
	client: `${PRODUCT_NAME.client} logo`,
	design: `${PRODUCT_NAME.design} logo`,
	financial: `${PRODUCT_NAME.financial} logo`,
	sites: `${PRODUCT_NAME.sites} logo`,
	social: `${PRODUCT_NAME.social} logo`,
};
